import styled from 'styled-components';

export const StyledLoadingDialogSubtitle = styled.span`
    display: block;
    margin-top: 0.5rem;
    font-size: 0.875rem;
    font-weight: normal;
`;
